export type VanillaFaction =
  | "New Antioch"
  | "Trench Pilgrims"
  | "Iron Sultanate"
  | "Heretic Legions"
  | "Black Grail"
  | "Court of the Seven-Headed Serpent";

export const vanillaFactions: VanillaFaction[] = [
  "New Antioch",
  "Trench Pilgrims",
  "Iron Sultanate",
  "Heretic Legions",
  "Black Grail",
  "Court of the Seven-Headed Serpent",
];

// Variant display names for the create wizard.
// Note: the app’s premade data source (`src/data/premadeTemplates.ts`) uses "Standard" as the default variant key.
export const vanillaVariants: Record<VanillaFaction, string[]> = {
  "New Antioch": [
    "New Antioch",
    "Papal States Intervention Force",
    "Éire Rangers",
    "Kingdom of Alba Assault Detachment",
    "Stosstruppen of the Free State of Prussia",
    "Expeditionary Forces of Abyssinia",
  ],
  "Trench Pilgrims": [
    "Trench Pilgrims",
    "Procession of the Sacred Affliction",
    "War Pilgrimage of Saint Methodius",
    "Cavalcade of the Tenth Plague",
  ],
  "Iron Sultanate": ["Iron Sultanate"],
  "Heretic Legions": ["Heretic Legions"],
  "Black Grail": ["Black Grail"],
  "Court of the Seven-Headed Serpent": ["Court of the Seven-Headed Serpent"],
};

// Homebrew choices shown in the create wizard.
// The strings here should match (or closely match) `HOMEBREW_SETS[].name` in `src/data/homebrewSets.ts`.
export const homebrewByFaction: Record<string, string[]> = {
  "New Antioch": ["Byzantine Remnants"],
  "Heretic Legions": ["Cadaver Corps", "Harvesting Legion"],
  "Synod of Strategic Prophecy": ["Synod of Strategic Prophecy"],
  "Iron Sultanate": ["Assassin Redux", "Ghazi of the Golden Path (Sultanate Subfaction)"],
  "Court of the Seven-Headed Serpent": ["Knights of the Court"],
};

